module.exports = __webpack_public_path__ + "media/wyposazenie/zabezpieczenia-6ae09e22.png";